import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import AdminModal from '../../../reusable/admin-modal/admin-modal.component';
import Button from '../../../reusable/button/button.component';
import Spinner from '../../../reusable/spinner/spinner.component';
import { ToastContext } from '../../../../contexts/toast.context';
import Client from '../../../../tools/client';

import {
  Input,
  MainContainer,
  RowContainer,
  Title,
  Label,
  Toggle,
  Textarea,
  ContentContainer
} from '../../../../styles/component.styles';

const client = new Client();

const UpdatePage = ({ page, getPage, setShowUpdate }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [ showModal, setShowModal ] = useState(false);
  const [pageTypes, setPageTypes] = useState([]);

  const [title, setTitle] = useState(page.title || '');
  const [description, setDescription] = useState(page.description || '');
  const [isActive, setIsActive] = useState(page.isActive ?? true);
  const [pageTypeId, setPageTypeId] = useState(
    page.pageTypeId
      ? { value: page.pageTypeId, label: 'Loading...' } // label will be replaced after fetch
      : null
  );

  const { errorToast, successToast } = useContext(ToastContext);

  useEffect(() => {
    const fetchPageTypes = async () => {
      const res = await client.getPageTypes();
      if (Array.isArray(res)) {
        const options = res.map((pt) => ({ value: pt.id, label: pt.name }));
        setPageTypes(options);

        // If current pageTypeId exists, sync it to options
        const current = options.find((opt) => opt.value === page.pageTypeId);
        if (current) setPageTypeId(current);
      }
    };
    fetchPageTypes();
  }, [page.pageTypeId]);

  const deletePage = async () => {
    await client.deletePage(page.id);
    navigate(`/content-management`);
  };

  const submitUpdate = async () => {
    if (!title) return errorToast('Title is required');
    if (!pageTypeId) return errorToast('Please select a Page Type');

    setLoading(true);

    const data = {
      title,
      description,
      pageTypeId: pageTypeId.value,
      isActive
    };

    const res = await client.updatePage(page.id, data);

    if (res.status === 400) {
      errorToast(res.message);
      setLoading(false);
      return;
    }

    successToast('Page Updated');
    await getPage();
    setLoading(false);
    setShowUpdate(false);
  };

  return (
    <MainContainer>
      <AdminModal 
          show={showModal}
          setShow={setShowModal}
          title={'Delete Page'} 
          image={''}
          message={`Are you sure you want to delete this page? This action can not be undone.`}
          action={deletePage} 
          actionText={'Confirm'}
      />
      {loading ? (
        <Spinner />
      ) : (
        <ContentContainer>
          <Title>Update Page</Title>

          <Input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Title *"
          />

          {pageTypes.length > 0 && (
            <>
              <Label>Page Type *</Label>
              <div style={{ marginBottom: '16px' }}>
                <Select
                  options={pageTypes}
                  value={pageTypeId}
                  onChange={(selected) => setPageTypeId(selected)}
                  placeholder="Select Page Type"
                  isSearchable
                />
              </div>
            </>
          )}

          {/* <Label>Description</Label>
          <Textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Optional short description"
          /> */}

          <ContentContainer margin={'20px auto'}>
            <Label>Active</Label>
            <Toggle>
              <input
                type="checkbox"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
                />
              <span></span>
            </Toggle>
          </ContentContainer>

          <RowContainer margin={'20px auto'}>
            <Button onClick={() => setShowUpdate(false)}>Cancel</Button>
            <Button onClick={submitUpdate}>Confirm</Button>
          </RowContainer>

          <Button onClick={() => setShowModal(true)} color="danger">DELETE</Button>
        </ContentContainer>
      )}
    </MainContainer>
  );
};

export default UpdatePage;